import { useParams } from 'react-router-dom'
import { observer, useLocalObservable } from 'mobx-react-lite'

import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import { usePhotoStore } from '../../../store/PhotoContext'
import { PublicAlbumQueryStore } from '../../../store/PublicAlbumQueryStore'
import { usePublicAlbumInfoLoaderData } from '../AlbumInfo/AlbumInfo.loaders'

import { AlbumContainer } from './Album.container'

export const PublicAlbumContainer = observer(function PublicAlbumContainer() {
  const { shareId = '', mediaId = '' } = useParams()
  const { album: albumInfo } = usePublicAlbumInfoLoaderData()
  const photoStore = usePhotoStore()
  const store = useLocalObservable(
    () => new PublicAlbumQueryStore(shareId, photoStore, albumInfo),
  )
  const album = store.album

  return (
    <>
      <LoadingOverlay id="PublicAlbum.container" open={store.isLoading} />
      {album && <AlbumContainer album={album} mediaId={mediaId} />}
    </>
  )
})
